"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.commifiedRoundedNumberString = exports.numberStringRound = void 0;
var units_1 = require("@ethersproject/units");
var decimal_js_1 = require("decimal.js");
function numberStringRound(value, precision) {
    return new decimal_js_1.Decimal(value).toFixed(precision, decimal_js_1.Decimal.ROUND_UP);
}
exports.numberStringRound = numberStringRound;
function commifiedRoundedNumberString(value, precision) {
    return (0, units_1.commify)(new decimal_js_1.Decimal(value).toFixed(precision, decimal_js_1.Decimal.ROUND_UP));
}
exports.commifiedRoundedNumberString = commifiedRoundedNumberString;
